export const reduceObject = <T, R>(jsObject: { [key: string]: T }, initResult: R, callbackFn: (key: string, value: T, prev: R) => R): R =>
    Object.keys(jsObject).reduce((prev, key) => callbackFn(key, jsObject[key], prev), initResult)

export const removeNullAttributes = <T>(obj: T): T =>
    reduceObject(obj as any, {} as any, (key, curr, prev) => {
        if (curr != null && curr !== undefined) prev[key] = curr
        return prev
    })
